import { useEffect } from 'react';
import SelectOrder from '../../components/select/SelectOrder';

const StepOrder = ({
  totalAmount,
  apiUrl,
  apiFilter = 'status[ne][]=1&status[ne][]=2',
  dataCollection,
  updateDataCollection,
  activeStep,
  setActiveStep,
  step,
  updateValidation,
  button,
  noTemplate,
  onClose = () => {},
}) => {
  function handleOrderSelect(order) {
    const insertData = {
      order: order,
      recipient: order.recipient,
      recipientType: order.recipientType,
      title: order.title,
    };
    updateDataCollection(insertData);

    //next step
    setActiveStep(activeStep + 1);
  }

  useEffect(() => {
    if (dataCollection && dataCollection.order) updateValidation(true);
  }, []);

  return (
    <SelectOrder
      totalAmount={totalAmount}
      apiUrl={apiUrl}
      onSelect={handleOrderSelect}
      filter={apiFilter}
      selected={dataCollection && dataCollection.order}
      button={button}
    />
  );
};

export default StepOrder;
